import dayjs from "dayjs";

function formatSeconds(seconds) {
  const time = dayjs()
    .startOf("day")
    .add(seconds, "second");
  return time.format("mm:ss");
}



export class CountDown {
  seconds = 0;
  intervalId = null;
  callback = null;

  count = 0;

  constructor(callback) {
    this.callback = callback;
  }

  loop() {
    this.stopLoop();
    this.count = this.seconds;
    this.callback && this.callback(formatSeconds(this.count));
    this.intervalId = setInterval(() => {
      this.count--;
      this.callback && this.callback(formatSeconds(this.count));
      if (this.count <= 0) {
        this.stopLoop();
      }
    }, 1000);
  }

  stopLoop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  start(s, force = false) {
    const seconds = s;

    if (force) {
      this.seconds = seconds;
      this.loop();
      return;
    }

    if (seconds !== this.seconds) {
      this.seconds = seconds;
      this.loop();
    }
  }

  stop() {
    this.stopLoop();
  }
}
